"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isRetriableStatus(status) {
    return status == 449 /* RetryWith */
        || status == 408 /* RequestTimeout */
        || status == 502 /* BadGateway */
        || status < 100 /* Continue */
        || status > 599 /* LastValidStatusCode */;
}
exports.default = isRetriableStatus;
